module.exports = __webpack_public_path__ + "media/goforajourney/img/our-story-97079b148723d6496b37618799915bbe.jpg";